export default __webpack_public_path__ + "static/media/bo-shoppers-profile.76a965a4.png";